<template>
  <qx-auto-complete v-model="supplierValue"
                    :disabled="disabled"
                    :fetch-suggestions="supplierSearch"
                    :orderDefaultValue="defaultValue"
                    @select="selectItem"
                    :value-key="itemName"
                    :placeholder="placeholder"/>
</template>

<script>
import SearchObj from 'Components/common/search/SearchObj';
import AutoComplete from '../../../mixins/common/AutoComplete';

export default {
  name: 'CustUserNameAutoComplete',
  mixins: [AutoComplete],
  props: {
    placeholder: { type: String, default: '请输入客户负责人' },
    tagParam: { type: String, default: 'custUserId' },
    tagName: { type: String, default: '客户负责人' },
    aliasExist: { type: Boolean, default: false}
  },
  data() {
    return {
      url: '/user/leader?userName=',
      itemName: 'name'
    };
  },
  methods: {
    async supplierSearch(qs, cb) {
      if (qs && qs !== '') {
        const { data } = await
            this.qGet(`${this.url}${qs}&pageSize=5&pageNum=0`);
        if (this.aliasExist) {
          const filterData = data.filter(e=>(e.alias!==null&&e.alias!==""));
          cb(filterData);
        } else {
          cb(data);
        }
      } else {
        cb([]);
      }
    },
    async selectItem(item) {
      if (item !== null) {
        this.$emit('update:value', item[this.itemName]);
        this.$emit('setValue', {
          ...item,
          index: this.index
        });
        this.$emit('setTags', this.getCustUserNameSearchValue(item));
      }
    },
    getCustUserNameSearchValue(item) {
      return new SearchObj(
          this.tagParam, this.tagName, item.id, 'user', item.name
      ).tags;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
